module.exports = __webpack_public_path__ + "static/media/nuclear_chain_reaction.844f76a8.png";